import * as type from './types';

export function registerResendOtp(data) {
    // conso
    return {
        type: type.GET_REGISTER_RESEND_OTP_REQUESTED,
        data: data,
    }
}

export function clearRegisterResendOtpMessages() {
    return {
        type: type.CLEAR_REGISTER_RESEND_OTP_MESSAGES,
    }
}